import { NgModule } from "@angular/core";
import {
  MedBtnModule,
  MedCardModule,
  MedCheckboxModule,
  MedDirectiveSharedModule, MedModalModule,
  MedPaginationModule, MedRadioGroupModule,
  MedSwitchModule,
  MedTabGroupModule, MedUnitInfoCardModule,
} from "@mk/med-ui";
import { DatePipe, NgClass, NgForOf, NgIf, NgStyle } from "@angular/common";
import { SharedModule } from "primeng/api";
import { TableModule } from "primeng/table";
import { AccordionModule } from "primeng/accordion";
import {
  MedIconAimbulanceModule,
  MedIconArrowRightModule, MedIconAvatarModule, MedIconCheckCircleFillModule, MedIconDeleteModule,
  MedIconKeyLargeModule,
  MedIconNotificationModule, MedIconSyncModule,
} from "@mk/med-icons";
import { BasketComponent } from "@app/components/basket/basket.component";
import { PageTitleModule } from "@app/components/page-title/page-title.module";
import { TooltipModule } from "primeng/tooltip";

@NgModule({
  declarations: [
    BasketComponent,
  ],
  imports: [
    PageTitleModule,
    MedDirectiveSharedModule,
    MedSwitchModule,
    MedTabGroupModule,
    DatePipe,
    MedCheckboxModule,
    MedPaginationModule,
    MedRadioGroupModule,
    NgForOf,
    NgIf,
    SharedModule,
    TableModule,
    AccordionModule,
    MedCardModule,
    NgStyle,
    MedBtnModule,
    MedIconNotificationModule,
    MedIconKeyLargeModule,
    MedIconAimbulanceModule,
    MedUnitInfoCardModule,
    MedIconArrowRightModule,
    MedIconDeleteModule,
    MedModalModule,
    NgClass,
    MedIconAvatarModule,
    MedIconCheckCircleFillModule,
    TooltipModule,
    MedIconSyncModule,
  ],
  exports: [],
})
export class BasketModule {}
